import React from 'react';
import Error500 from '../../../pages/Error500';

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error) {
    const isChunkError =
      error?.name === 'ChunkLoadError' ||
      /Loading chunk [\d]+ failed/i.test(error?.message || '');

    if (isChunkError) {
      const alreadyReloaded = sessionStorage.getItem('chunk-error-reloaded');
      if (!alreadyReloaded) {
        sessionStorage.setItem('chunk-error-reloaded', '1');
        window.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return <Error500 />;
    }
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
